import { formatPhone } from 'utils/helpers';
import { Input } from 'components/Profile';
import { RELATIONSHIPS } from './helper';

const NewPerson = () => (
  <div className="grid grid-cols-1 gap-x-4 gap-y-3 bg-blue-50/60 px-4 pb-5 pt-1 animate-slide-up sm:grid-cols-2 sm:px-5">
    <Input name="first_name" label="First name" placeholder="Sam" />
    <Input name="last_name" label="Last name" placeholder="Carter" />
    <Input name="phone" label="Phone" placeholder="(555) 000-0000" format={formatPhone} />

    <Input name="relationship" label="Relationship" as="select" inputClassName="font-normal">
      <option value="">Select…</option>
      {RELATIONSHIPS.map((relationship) => (
        <option key={relationship} value={relationship}>{relationship}</option>
      ))}
    </Input>
  </div>
);

export default NewPerson;
